import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Mail, X, Loader2 } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "../../context/AuthContext";
import { authApi, errorMessage } from "../../lib/api";

// In-app reminder for phone-only users (no real email on file) to add & verify one.
// Snoozable for 7 days via the backend; also dismissable for the current session.
export default function AddEmailReminder() {
  const { user, setUser } = useAuth();
  const navigate = useNavigate();
  const [hidden, setHidden] = useState(false);
  const [busy, setBusy] = useState(false);

  if (!user || !user.email_placeholder || hidden) return null;
  const snoozedUntil = user.email_reminder_snoozed_until ? new Date(user.email_reminder_snoozed_until) : null;
  if (snoozedUntil && snoozedUntil.getTime() > Date.now()) return null;

  const snooze = async () => {
    setBusy(true);
    try { const u = await authApi.snoozeEmailReminder(); setUser(u); toast.success("We'll remind you in 7 days"); }
    catch (e) { toast.error(errorMessage(e)); } finally { setBusy(false); }
  };

  return (
    <div className="fixed bottom-4 left-1/2 z-40 w-[92%] max-w-md -translate-x-1/2 rounded-2xl border border-brand-200 bg-white p-4 shadow-lg" data-testid="add-email-reminder">
      <button onClick={() => setHidden(true)} className="absolute right-2 top-2 text-ink-muted hover:text-ink" data-testid="add-email-dismiss"><X className="h-4 w-4" /></button>
      <div className="flex items-start gap-3">
        <div className="rounded-full bg-brand-50 p-2"><Mail className="h-5 w-5 text-brand" /></div>
        <div className="flex-1">
          <p className="text-sm font-semibold text-ink">Add your email address</p>
          <p className="mt-0.5 text-xs text-ink-soft">Add an email to get order confirmations and recover your account. We'll verify it with a quick code.</p>
          <div className="mt-3 flex flex-wrap gap-2">
            <button onClick={() => { setHidden(true); navigate("/app/profile"); }} className="rounded-full bg-brand px-4 py-1.5 text-xs font-semibold text-white hover:bg-brand-600" data-testid="add-email-cta">Add email</button>
            <button onClick={snooze} disabled={busy} className="inline-flex items-center rounded-full border border-surface-300 px-4 py-1.5 text-xs font-semibold text-ink hover:bg-surface-100 disabled:opacity-60" data-testid="add-email-snooze">{busy && <Loader2 className="mr-1.5 h-3 w-3 animate-spin" />}Remind me in 7 days</button>
          </div>
        </div>
      </div>
    </div>
  );
}
